<template>
    <div>
        <app-wysiwyg
            label="Überschrift"
            :data-source="'tecpage.user.modules.' + moduleId + '.data.title'"
            :maxlength="255"
            :slim="true"
        ></app-wysiwyg>

        <app-wysiwyg
            label="Unterüberschrift"
            :data-source="'tecpage.user.modules.' + moduleId + '.data.subtitle'"
            :maxlength="255"
            :slim="true"
        ></app-wysiwyg>

        <app-wysiwyg
            label="Text oben"
            :data-source="'tecpage.user.modules.' + moduleId + '.data.text1'"
        ></app-wysiwyg>

        <app-list
            :data-source="'tecpage.user.modules.' + moduleId + '.data.slides'"
            :data-preset="false"
            :data-name="'data.title'"
            :list-label="'Bild'"
            :list-subpage="'Album'"
            :allow-individual="true"
            :label="'Bild'"
        ></app-list>

        <app-wysiwyg
            label="Text unten"
            :data-source="'tecpage.user.modules.' + moduleId + '.data.text2'"
        ></app-wysiwyg>

        <app-link
            label="Button 1"
            :data-source="'tecpage.user.modules.' + moduleId + '.data.link'"
        ></app-link>

        <app-link
            label="Button 2"
            :data-source="'tecpage.user.modules.' + moduleId + '.data.link2'"
        ></app-link>

        <app-link
            label="Button 3"
            :data-source="'tecpage.user.modules.' + moduleId + '.data.link3'"
        ></app-link>
    </div>
</template>

<script>
import List from '@/components/fields/complex/List.vue';
import Select from '@/components/fields/simple/Select.vue';
import Wysiwyg from '@/components/fields/simple/Wysiwyg.vue';
import Link from '@/components/assorted/Link.vue';

export default {
    data() {
        return {};
    },
    methods: {},
    computed: {},
    mounted() {
        this.$emit('controlhead', {
            title: this.$helpers.uiText('R005'),
            help: this.$helpers.uiText('R092'),
            removeText: this.$helpers.uiText('R026'),
            showGlobal: false
        });
    },
    props: {
        moduleId: String
    },
    components: {
        'app-list': List,
        'app-select': Select,
        'app-wysiwyg': Wysiwyg,
        'app-link': Link
    }
};
</script>
